import clsx from "clsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./zero-state-message.scss";

export function ZeroStateMessage({
  role,
  className,
  onShowButton,
  filtered,
  containerLabel = "organization",
  statusLabel,
}) {
  const statusPrefix =
    statusLabel && statusLabel !== "all" ? `${statusLabel} ` : "";
  const suffix = filtered
    ? "with the applied filter"
    : `for this ${containerLabel}`;
  const emptyStateText = `There are no ${statusPrefix}${role.pluralDisplayName} ${suffix}. `;

  return (
    <div
      className={clsx(
        "zero-state-message",
        className,
        onShowButton && "clickable"
      )}
    >
      <div className="text">
        <FontAwesomeIcon icon={["fa-light", "user-plus"]} />
        {onShowButton ? (
          <button onClick={onShowButton}>
            {emptyStateText}
            Tap to add a new one.
          </button>
        ) : (
          <span>{emptyStateText}</span>
        )}
      </div>
    </div>
  );
}
